import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import {
  Page,
  LayoutSingleColumn,
  H1,
  H2,
} from '../../components';
import ContactUsForm from '../../components/ContactUsForm/ContactUsForm';

import css from './ContactUsPage.module.css';

export const ContactUsPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const title = intl.formatMessage({ 
    id: 'ContactUsPage.title',
    defaultMessage: 'Contact Us'
  });

  const metaDescription = intl.formatMessage({
    id: 'ContactUsPage.metaDescription',
    defaultMessage: 'Get in touch with us. We\'re here to help with any questions or concerns you may have.'
  });

  return (
    <Page
      title={title}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ContactPage',
        description: metaDescription,
        name: title,
      }}
    >
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.mainWrapper}>
          <div className={css.content}>
            <div className={css.headerSection}>
              <H1 className={css.title}>
                <FormattedMessage 
                  id="ContactUsPage.heading" 
                  defaultMessage="Get In Touch"
                />
              </H1>
              <p className={css.description}>
                <FormattedMessage 
                  id="ContactUsPage.description" 
                  defaultMessage="Have a question or need assistance? We're here to help! Fill out the form below and our team will get back to you as soon as possible."
                />
              </p>
            </div>

            <div className={css.formSection}>
              <ContactUsForm />
            </div>

            <div className={css.infoSection}>
              <H2 className={css.infoTitle}>
                <FormattedMessage 
                  id="ContactUsPage.otherWaysTitle" 
                  defaultMessage="Other Ways to Reach Us"
                />
              </H2>
              <p className={css.infoText}>
                <FormattedMessage 
                  id="ContactUsPage.responseTime" 
                  defaultMessage="We typically respond within 24-48 hours during business days."
                />
              </p>
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const ContactUsPage = compose(
  connect(mapStateToProps),
  injectIntl
)(ContactUsPageComponent);

export default ContactUsPage;
